import { render, staticRenderFns } from "./BackInIcon.vue?vue&type=template&id=273e9b5c&"
import script from "./BackInIcon.vue?vue&type=script&lang=js&"
export * from "./BackInIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports